module.exports = __webpack_public_path__ + "img/gh-20820.asm.be1f03e4.jpg";